export default __webpack_public_path__ + "static/media/computadora.16ba5bc1.svg";